// extracted by mini-css-extract-plugin
export default {"formProduct":"formProduct_formProduct__dAkRN","box":"formProduct_box__yjE2e","lableField":"formProduct_lableField__1Ug8s"};